module.exports = __webpack_public_path__ + "static/media/internet.f1f4bb29.svg";